export const lightTheme = {
    color:"black",
    background: 'white',
}
export const darkTheme = {
    color:"white",
    backgroundColor: 'black',
}